import React, { useState } from "react";
import BusinessUserManagement from "./BusinessUserManagement";
import CalendarView from "./CalendarView";
import DailyItemsManagement from "./DailyItemsManagement";
import DeliveryTracking from "./DeliveryTracking";
import BusinessProfileEdit from "./BusinessProfileEdit";
import AssignmentResponses from "./AssignmentResponses";

const AdminDashboard = ({ user }) => {
  const [activeTab, setActiveTab] = useState("users");
  const [showProfileEdit, setShowProfileEdit] = useState(false);
  const [currentUser, setCurrentUser] = useState(user);

  const handleProfileUpdate = (updatedUser) => {
    setCurrentUser(updatedUser);
  };

  const renderActiveTab = () => {
    switch (activeTab) {
      case "users":
        return <BusinessUserManagement user={currentUser} />;
      case "calendar":
        return <CalendarView user={currentUser} />;
      case "dailyItems":
        return <DailyItemsManagement user={currentUser} />;
      case "deliveries":
        return <DeliveryTracking user={currentUser} />;
      case "assignment-responses":
        return <AssignmentResponses />;
      case "profile":
        return (
          <div className="card">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h2>Business Profile</h2>
              <button
                className="btn btn-primary"
                onClick={() => setShowProfileEdit(true)}
              >
                ✏️ Edit Profile
              </button>
            </div>
            <div
              style={{
                backgroundColor: "#f8f9fa",
                padding: "20px",
                borderRadius: "8px",
                marginTop: "20px",
              }}
            >
              <div style={{ marginBottom: "15px" }}>
                <strong>Business Name:</strong> {currentUser.businessName}
              </div>
              <div style={{ marginBottom: "15px" }}>
                <strong>Business Type:</strong> {currentUser.businessType}
              </div>
              <div style={{ marginBottom: "15px" }}>
                <strong>Username:</strong> {currentUser.username}
              </div>
              <div style={{ marginBottom: "15px" }}>
                <strong>Email:</strong> {currentUser.email}
              </div>
              <div style={{ marginBottom: "15px" }}>
                <strong>Phone:</strong>{" "}
                {currentUser.businessPhone || "Not provided"}
              </div>
              <div style={{ marginBottom: "15px" }}>
                <strong>Website:</strong>{" "}
                {currentUser.website || "Not provided"}
              </div>
              {currentUser.businessAddress && (
                <div style={{ marginBottom: "15px" }}>
                  <strong>Address:</strong> {currentUser.businessAddress.street}
                  , {currentUser.businessAddress.city},{" "}
                  {currentUser.businessAddress.state}{" "}
                  {currentUser.businessAddress.zipCode}
                </div>
              )}
              {currentUser.contactPerson && (
                <div style={{ marginBottom: "15px" }}>
                  <strong>Contact Person:</strong>{" "}
                  {currentUser.contactPerson.firstName}{" "}
                  {currentUser.contactPerson.lastName} (
                  {currentUser.contactPerson.email})
                </div>
              )}
              <div style={{ marginBottom: "15px" }}>
                <strong>Account Status:</strong>
                <span style={{ color: "#28a745", marginLeft: "10px" }}>
                  Active
                </span>
              </div>
              {currentUser.isVerified && (
                <div style={{ marginBottom: "15px" }}>
                  <strong>Verification Status:</strong>
                  <span style={{ color: "#28a745", marginLeft: "10px" }}>
                    ✓ Verified
                  </span>
                </div>
              )}
            </div>
          </div>
        );
      default:
        return <BusinessUserManagement user={currentUser} />;
    }
  };

  return (
    <div className="container">
      <div className="card">
        <h1>👨‍💼 Business Dashboard</h1>
        <p>Welcome back, {currentUser.username}!</p>

        <div className="dashboard-tabs" style={{ marginTop: "30px" }}>
          <button
            className={`dashboard-tab ${activeTab === "users" ? "active" : ""}`}
            onClick={() => setActiveTab("users")}
          >
            <div className="dashboard-tab-icon">👥</div>
            <div className="dashboard-tab-label">User Management</div>
          </button>
          <button
            className={`dashboard-tab ${
              activeTab === "dailyItems" ? "active" : ""
            }`}
            onClick={() => setActiveTab("dailyItems")}
          >
            <div className="dashboard-tab-icon">📦</div>
            <div className="dashboard-tab-label">Daily Items</div>
          </button>
          <button
            className={`dashboard-tab ${
              activeTab === "deliveries" ? "active" : ""
            }`}
            onClick={() => setActiveTab("deliveries")}
          >
            <div className="dashboard-tab-icon">🚚</div>
            <div className="dashboard-tab-label">Delivery Tracking</div>
          </button>
          <button
            className={`dashboard-tab ${
              activeTab === "assignment-responses" ? "active" : ""
            }`}
            onClick={() => setActiveTab("assignment-responses")}
          >
            <div className="dashboard-tab-icon">📊</div>
            <div className="dashboard-tab-label">Assignment Responses</div>
          </button>
          <button
            className={`dashboard-tab ${
              activeTab === "calendar" ? "active" : ""
            }`}
            onClick={() => setActiveTab("calendar")}
          >
            <div className="dashboard-tab-icon">📅</div>
            <div className="dashboard-tab-label">Calendar</div>
          </button>
          <button
            className={`dashboard-tab ${
              activeTab === "profile" ? "active" : ""
            }`}
            onClick={() => setActiveTab("profile")}
          >
            <div className="dashboard-tab-icon">🏢</div>
            <div className="dashboard-tab-label">Business Profile</div>
          </button>
        </div>

        <div style={{ marginTop: "30px" }}>{renderActiveTab()}</div>
      </div>

      {showProfileEdit && (
        <BusinessProfileEdit
          user={currentUser}
          onProfileUpdate={handleProfileUpdate}
          onCancel={() => setShowProfileEdit(false)}
        />
      )}
    </div>
  );
};

export default AdminDashboard;
